import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Breadcrumbs from "../components/Breadcrumbs";
import SiteShell from "../components/SiteShell";
import { bookServicePath, primaryNav } from "../siteData";

export default function NotFound() {
  return (
    <SiteShell>
      <Helmet><title>Page not found | Prime Path Motors</title><meta name="robots" content="noindex" /></Helmet>
      <section className="not-found">
        <Breadcrumbs trail={[["Page not found", "/404"]]} />
        <p className="eyebrow">404 · Wrong turn</p>
        <h1>This road does not continue.</h1>
        <p>The page may have moved, or the address may be incorrect. Here is everywhere else.</p>
        <nav className="not-found-links" aria-label="Site sections">
          {primaryNav.filter((item) => item.to !== "/").map((item) => (
            <Link key={item.to} to={item.to}>{item.label}</Link>
          ))}
        </nav>
        <div className="button-row">
          <Link className="button button-gold" to="/">Return home</Link>
          <Link className="button button-outline" to={bookServicePath}>Book Service</Link>
        </div>
      </section>
    </SiteShell>
  );
}
